import React from 'react';
import PropTypes from 'prop-types';
import { CodeEditor } from 'axway-react-ui';
import { Button, Modal } from 'react-bootstrap';
import cn from 'classnames';
import { injectIntl } from 'react-intl';
import IntlComponent from 'axway-react-intl';

class PluginInUseView extends React.Component {
	constructor(props) {
		super(props);
		IntlComponent.init(this);
		this.state = {
			showDetails: false
		};
		this.toggleDetails = this.toggleDetails.bind(this);
		this.renderBody = this.renderBody.bind(this);
	}

	toggleDetails(ev) {
		ev.stopPropagation();
		ev.preventDefault();
		this.setState({ showDetails: !this.state.showDetails });
	}

	renderBody() {
		if (!this.state.showDetails) {
			return (
				<div>
					{this.intl.formatHTMLMsg('The plugin {package} cannot be uninstalled because it is currently in use. You should remove any references to flow-nodes, models or other components before uninstalling.',
						{ package: <code>{this.props.plugin.package}</code> })}
				</div>
			);
		} else {
			return (
				<CodeEditor
					code={this.props.plugin.usage.in}
					readOnly
					lineWrapping={false}
					nocursor
					lineNumbers={false}
					copyButton
					mode="javascript"
				/>
			);
		}
	}

	render() {
		const { onClose } = this.props;
		return (
			<Modal
				show
				backdrop="static"
				keyboard={false}
				className="uninstall-confirm-view"
			>
				<Modal.Header>
					<Modal.Title>
						{this.intl.formatMsg('This plugin is in use')}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body className={cn({ large: this.state.showDetails })}>
					{this.renderBody()}
				</Modal.Body>
				<Modal.Footer>
					<span className="modal-footer-action">
						<a
							onClick={this.toggleDetails}
							href="#"
						>
							{this.state.showDetails
								? this.intl.formatMsg('Hide details')
								: this.intl.formatMsg('Show details')}
						</a>
					</span>
					<Button
						bsStyle="primary"
						bsSize="large"
						className="okay"
						onClick={onClose}
					>
						Close
					</Button>
				</Modal.Footer>
			</Modal>
		);
	}
}

PluginInUseView.propTypes = {
	plugin: PropTypes.object.isRequired,
	onClose: PropTypes.func.isRequired
};

export default injectIntl(PluginInUseView);
